<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">Inventory Receipts Report</h1>
    <div class="flex items-center mb-6">
      <search-with-date-range v-model="form.search" class="mr-0 w-full max-w-md mr-3"/>
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-2 pt-2 px-3">Date</th>
          <th class="pb-2 pt-2 px-3">Part Number</th>
          <th class="pb-2 pt-2 px-3">Part Description</th>
          <th class="pb-2 pt-2 px-3">Category</th>
          <th class="pb-2 pt-2 px-3">Count</th>
          <th class="pb-2 pt-2 px-3">Quantity</th>
          <th class="pb-2 pt-2 px-3">UoM</th>
          <th class="pb-2 pt-2 px-3">Location</th>
        </tr>
        <tr
          v-for="inventory in inventories.data"
          :key="inventory.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <span class="flex items-center px-3 py-2 focus:text-indigo-500">
              {{ inventory.date }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-2 focus:text-indigo-500">
              {{ inventory.sku_name }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-2 focus:text-indigo-500">
              {{ inventory.description }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-2 focus:text-indigo-500">
              {{ inventory.category }}
            </span>
          </td>
          <td class="w-px border-t">
            <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
              {{ inventory.total }}
            </span>
          </td>
          <td class="w-px border-t">
            <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
              {{ inventory.quantity.toFixed(2) }}
            </span>
          </td>
          <td class="w-px border-t text-center">
            <span class="flex items-center px-3 py-2 focus:text-indigo-500">
              {{ inventory.unit_of_measure }}
            </span>
          </td>
          <td class="w-px border-t text-center">
            <span class="flex items-center px-3 py-2 focus:text-indigo-500">
              {{ inventory.location }}
            </span>
          </td>
        </tr>
        <tr v-if="inventories.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="8">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="inventories.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchWithDateRange,
    DateRange,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    inventories: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        dateValue: this.filters.dateValue
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/inventory/reports', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
